import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Lottie from "react-lottie-player";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { QRCodeCanvas } from "qrcode.react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Divider
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

// Fondo animado
import rayoazul from "./assets/lottie/rayoazul.json";

export default function SuccessPage() {
    const navigate = useNavigate();

    // 🧹 Borrar carrito SIEMPRE al entrar aquí
try {
  localStorage.removeItem("carrito");
  localStorage.removeItem("productos");
} catch {
  console.log("Error limpiando carrito:");}

    useEffect(() => {
      try {
        console.log("Limpiando carrito desde Success — antes:", localStorage.getItem("carrito"));
        // Guardar explicitamente un array vacío para que cualquier lectura JSON.parse devuelva []
        localStorage.setItem("carrito", JSON.stringify([]));
        localStorage.setItem("productos", JSON.stringify([]));
    
        // NOTIFICAR al resto de la app (mismo tab) que el carrito cambió
        window.dispatchEvent(new CustomEvent("carritoActualizado", { detail: [] }));
    
        console.log("Carrito después:", localStorage.getItem("carrito"));
      } catch {
        console.error("Error limpiando carrito:");
      }
    }, []);
    
  
    function CardTranslucido({ navigate }) {
      const [progress, setProgress] = React.useState(0);
      const [complete, setComplete] = React.useState(false);
  
      // Animación 0–100
      React.useEffect(() => {
        let current = 0;
        const interval = setInterval(() => {
          current += 4;
          if (current >= 100) {
            current = 100;
            setComplete(true);
            clearInterval(interval);
          }
          setProgress(current);
        }, 45);
        return () => clearInterval(interval);
      }, []);
  
      return (
        <div
          style={{
            width: "90%",
            maxWidth: "clamp(280px, 50vw, 360px)",
            borderRadius: "clamp(14px, 2.5vw, 22px)",
            backgroundColor: "rgba(41,40,40,0.50)",
            backdropFilter: "blur(6px)",
            padding: "clamp(16px, 3vw, 26px)",
            boxShadow: "0 0 18px rgba(0,0,0,0.45)",
            pointerEvents: "auto",
            textAlign: "center",
          }}
        >
          {/* Logo circular */}
          <div
            style={{
              width: "clamp(85px, 20vw, 120px)",
              height: "clamp(85px, 20vw, 120px)",
              margin: "0 auto",
              borderRadius: "50%",
              backgroundColor: "#26e9f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            }}
          >
            <div
              style={{
                width: "clamp(74px, 18vw, 108px)",
                height: "clamp(74px, 18vw, 108px)",
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "#444",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={"images/dragonfondo.png"}
                alt="logo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "dragonfondo.png";
                }}
              />
            </div>
          </div>
  
          {/* Barra progreso */}
          {!complete && (
            <>
              <div
                style={{
                  width: "100%",
                  height: "clamp(8px, 1.8vw, 12px)",
                  backgroundColor: "#ccc",
                  borderRadius: "clamp(4px, 1vw, 8px)",
                  marginTop: "clamp(14px, 2.5vw, 20px)",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${progress}%`,
                    height: "100%",
                    background: "linear-gradient(90deg, #00e5ff, #00b3cc)",
                    transition: "width 0.15s ease",
                  }}
                />
              </div>
  
              <p
                style={{
                  marginTop: "clamp(6px, 1.2vw, 10px)",
                  color: "#eee",
                  fontWeight: "bold",
                  fontSize: "clamp(11.5px, 2.4vw, 15px)",
                }}
              >
                Cargando éxito... {progress}%
              </p>
            </>
          )}
  
          {complete && (
            <div style={{ marginTop: "clamp(16px, 3vw, 24px)", color: "white" }}>
             <h3
  style={{
    margin: 0,
    fontSize: "clamp(13px, 3vw, 18px)",
    fontWeight: "bold",
    color: "#00eaff"
  }}
>
  ¡Pago acreditado con éxito! 🎉
</h3>

<p
  style={{
    marginTop: "clamp(8px, 1.8vw, 13px)",
    opacity: 0.9,
    fontSize: "clamp(10.5px, 2.7vw, 14px)",
  }}
>
  Gracias por tu compra.<br />
  Estamos procesando tu pedido y recibirás los detalles por correo.
</p>

  
              <button
                style={{
                  marginTop: "clamp(14px, 2.7vw, 22px)",
                  width: "100%",
                  backgroundColor: "#2EBF81",
                  padding: "clamp(9px, 2.4vw, 13px)",
                  fontSize: "clamp(13px, 2.8vw, 17px)",
                  borderRadius: "clamp(8px, 1.8vw, 14px)",
                  border: "none",
                  color: "white",
                  fontWeight: "bold",
                  cursor: "pointer",
                  boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                }}
                onClick={() => alert("Aquí descargas el comprobante")}
              >
                Descargar Comprobante
              </button>
            </div>
          )}
        </div>
      );
    }
  
    return (
      <>
        {/* Fondo negro */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "black",
            zIndex: 0,
          }}
        />
  
        {/* Lottie */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
            pointerEvents: "none",
          }}
        >
          <Lottie
            animationData={rayoazul}
            play
            loop
            style={{ width: "100%", height: "100%" }}
          />
        </div>
  
        {/* Botón regresar más pequeño */}
        <button
  onClick={() => navigate("/", { replace: true })}
  style={{
    position: "fixed",
    top: "clamp(10px, 2vw, 22px)",
    left: "clamp(10px, 2vw, 22px)",
    zIndex: 3,
    background: "rgba(0,0,0,0.45)",
    color: "white",
    padding: "clamp(5px, 1.5vw, 10px) clamp(8px, 2.5vw, 14px)",
    borderRadius: "clamp(6px, 1.2vw, 10px)",
    border: "1px solid rgba(255,255,255,0.25)",
    cursor: "pointer",
    fontSize: "clamp(11px, 2.7vw, 15px)",
    backdropFilter: "blur(4px)",
  }}
>
  ← Regresar
</button>

  
        {/* Card */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
            pointerEvents: "none",
          }}
        >
          <CardTranslucido navigate={navigate} />
        </div>
      </>
    );
  }
  